import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { APIURL, SOCETCONNURL } from "../../redux/action/config";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import logo from "../../assets/images/logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { fleetList } from "../../redux/action/fleet";
import { Formik } from "formik";
import { staffList } from "../../redux/action/staff";
import { toast } from "react-toastify";
import loader from "../../components/loader/loader";
import {
  addNoteToOrder,
  pushNotificationClient,
  updateOrder,
  updateOrderFleet,
} from "../../redux/action/order";

import {
  updateStaffStatus,
  enableStaffStatus,
} from "../../redux/action/staff";
import {
  updateFleetStatus,
  enableFleetStatus,
} from "../../redux/action/fleet";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import dateFormat from "dateformat";
import { io } from "socket.io-client";

const EditOrders = () => {
  const [ordersDetails, setOrdersDetails] = useState();
  const [note, setNote] = useState("");
  const [successNotes, setSuccessNotes] = useState("");
  const [loading, setLoading] = useState(true);
  const [noteValue, setNoteValue] = useState("");

  const [order, setOrder] = useState([]);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [completing, setCompleting] = useState(false);

  const { id } = useParams();
  const dispatch = useDispatch();
  const FleetData = useSelector((state) => state.fleet.list);
  const StaffData = useSelector((state) => state.staff.list);
  const getOrderDetails = (id) => {
    setLoading(true);
    const token = localStorage.getItem("token");

    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .get(`${APIURL}/api/v1/order/${id}`, config)
      .then((response) => {
        setOrdersDetails(response.data);
        setOrder(response.data?.data?.order);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getOrderDetails(id);
    dispatch(fleetList());
    dispatch(staffList());
  }, [id, dispatch, successNotes]);

  useEffect(() => {
    const socket = io(SOCETCONNURL);
    socket.on("single-order", (items) => {
      setOrder(items);
    });
    socket.on("disconnect", () => {
      console.log("Socket disconnecting");
    });
  }, []);

  const orders = ordersDetails?.data?.order ? ordersDetails?.data?.order : "";

  const AllFleets = FleetData?.data?.fleet?.filter(
    (item) => item.status == "available"
  );
  const ALLStaffs =
    StaffData && StaffData?.filter((item) => item.status == "available");

  const assignedStaff =
    StaffData &&
    StaffData?.filter((item) => {
      return orders?.staffs_id?.id == item?._id;
    });
  const assignedFleet = FleetData?.data?.fleet?.filter(
    (item) => orders?.fleet_id?._id == item?._id
  );

  const paymentDetails =
    orders?.customer_id?.purched_memberships?.[0]?.transition?.[0];

  // Lets an admin close a job when the technician couldn't (e.g. the app
  // update failed) - mirrors what the staff app's "Repair Completed" does:
  // complete the order and free up the assigned staff and fleet vehicle.
  const canComplete =
    order?.status !== "order_completed" && order?.status !== "order_canceled";

  const handleMarkCompleted = async () => {
    setCompleting(true);
    const token = localStorage.getItem("token");
    try {
      await axios.patch(
        `${APIURL}/api/v1/order/${id}`,
        { status: "order_completed", task_status: "task_completed" },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const staffId = order?.staffs_id?.id || order?.staffs_id?._id || order?.staff_id;
      const fleetId = order?.fleet_id?._id || order?.fleet_id?.id;
      if (staffId) dispatch(enableStaffStatus(staffId));
      if (fleetId) dispatch(enableFleetStatus(fleetId));
      if (order?.customer_id?.customer_device_token) {
        pushNotificationClient(
          "Congratulations, task completed!",
          "We are glad to help you. Keep taking advantage of our services 😊",
          order?.customer_id?.customer_device_token
        );
      }
      toast.success("Order marked as completed!");
      setShowCompleteModal(false);
      getOrderDetails(id);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to mark order as completed"
      );
    } finally {
      setCompleting(false);
    }
  };
  const recentOrderStatus = (status) => {
    switch (status) {
      case "order_initiated":
        return "Order Initiated";
      case "order_placed":
        return "Order Placed";
      case "order_in_progress":
        return "Order In Progress";
      case "order_completed":
        return "Order Completed";
      case "order_canceled":
        return "Order Canceled";
      default:
    }
  };

  const recentOrderColor = (status) => {
    switch (status) {
      case "order_initiated":
        return "badge-light-dark";
      case "order_placed":
        return "badge-light-info";
      case "order_in_progress":
        return "badge-light-warning";
      case "order_completed":
        return "badge-light-success";
      case "order_canceled":
        return "badge-light-danger";
      default:
    }
  };
  const taskStatus = (status) => {
    switch (status) {
      case "n/a":
        return "Staff is not assigned";
      case "staff_assigned":
        return "Staff assigned";
      case "reached_at_location":
        return "Staff reached at location";
      case "setting_safety_items":
        return "Setting safety items";
      case "access_situation":
        return "Access situation";
      case "rectifiying_problem":
        return "Rectifiying problem";
      case "towing_required":
        return "Towing required";
      case "task_completed":
        return "Task completed";
      default:
    }
  };
  const taskStatusColor = (status) => {
    switch (status) {
      case "n/a":
        return "badge-light-dark";
      case "staff_assigned":
        return "badge-light-info";
      case "reached_at_location":
        return "badge-light-dark";
      case "setting_safety_items":
        return "badge-light-info";
      case "access_situation":
        return "badge-light-warning";
      case "rectifiying_problem":
        return "badge-light-info";
      case "towing_required":
        return "badge-light-danger";
      case "task_completed":
        return "badge-light-success";
      default:
    }
  };
  const sendMessage = ()=>{
    var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      var raw = JSON.stringify({
        phone: order?.customer_id?.phone,
        subject: 'Order Details!',
        message: `
Hi ${order?.customer_id?.firstName}, 

The status of your order no. ${order?.invoice_no} has been marked as active. 
A Roadside Response team member will be in touch soon. 
You can keep the track of status in the app too. 

Cheers & Regards, 
Team Roadside Response.`,
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch(`${APIURL}/api/v1/users/sendMessage`, requestOptions)
        .then(response => response.json())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
  }

  const addNote = () => {
    const payload = {
      notes: noteValue,
      orderId: id,
    };
    if (!id) return;
    if (!payload?.notes) {
      toast.error("Please enter valid notes!");
      return;
    }
    dispatch(
      addNoteToOrder(payload, (type) => {
        if (type === "success") {
          // setSuccessNotes(true);
          toast.success("Note added successfully!");
          setNote("");
          setTimeout(() => {
            getOrderDetails(id);
            setNoteValue();
          }, 1000);
        }
      })
    );
  };

  // console.log(noteValue)

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Service Requests" page="editOrders">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            {!loading && order?._id ? (
              <div className="row">
                <div className="col-xl-8 mb-5">
                  <div className="card">
                    <div className="card-body p-lg-20">
                      <div className="d-flex flex-column flex-xl-row">
                        <div className="flex-lg-row-fluid me-xl-18 mb-10 mb-xl-0">
                          <div className="mt-n1">
                            <div className="d-flex flex-stack pb-10">
                              <Link to="#">
                                <img alt="Logo" src={logo} />
                              </Link>
                              <div className="mb-8">
                                <span
                                  className={`badge ${recentOrderColor(
                                    order?.status
                                  )} me-2`}
                                >
                                  {recentOrderStatus(order?.status)}
                                </span>
                              </div>
                              {/* <Link to="#" className="btn btn-sm btn-success">
                              Pay Now
                            </Link> */}
                            </div>
                            {order?.emergencyMessage ? (
                              <div className="mb-8 emergency-data">
                                <div className="mb-1 fw-bolder fs-6 text-gray-800">
                                  Emergency Message:
                                </div>
                                <span
                                  className={`badge badge-light-danger me-2`}
                                >
                                  {order?.emergencyMessage}
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="m-0">
                              <div className="fw-bolder fs-3 text-gray-800 mb-8">
                                Order number #{order?.invoice_no}
                              </div>
                              <div className="d-flex mb-8">
                              <div className="fw-bolder fs-6 text-gray-800">
                              Date & Time:&nbsp;
                              </div>
                              <div>{order?.createdAt
                                        ? dateFormat(
                                          order?.createdAt,
                                            "mm/dd/yyyy HH:mm:ss"
                                          )
                                        : "N/A"}</div>
                              </div>
                              {/* <div className="row g-5 mb-11">
                              <div className="col-sm-6">
                                <div className="fw-bold fs-7 text-gray-600 mb-1">
                                  Issue Date:
                                </div>
                                <div className="fw-bolder fs-6 text-gray-800">
                                  {order?.user_id?.createdAt}
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="fw-bold fs-7 text-gray-600 mb-1">
                                  Due Date:
                                </div>
                                <div className="fw-bolder fs-6 text-gray-800 d-flex align-items-center flex-wrap">
                                  <span className="pe-2">
                                    {" "}
                                    {order?.user_id?.createdAt}
                                  </span>
                                  <span className="fs-7 text-danger d-flex align-items-center">
                                    <span className="bullet bullet-dot bg-danger me-2"></span>
                                    Due in 7 days
                                  </span>
                                </div>
                              </div>
                            </div> */}
                              <div className="row g-5 mb-10">
                                <div className="col-sm-6">
                                  {/* <div className="fw-bold fs-7 text-gray-600 mb-1">
                                  Issue For:
                                </div> */}
                                  <div className="fw-bolder fs-6 text-gray-800">
                                    Request by:
                                  </div>
                                  <div className="fw-bold fs-7 text-gray-600">
                                    {`${
                                      order?.customer_id?.firstName
                                        ? order?.customer_id?.firstName
                                        : ""
                                    } ${
                                      order?.customer_id?.lastName
                                        ? order?.customer_id?.lastName
                                        : ""
                                    }`}
                                  </div>
                                </div>
                                {/*<div className="col-sm-6">
                                  <div className="fw-bolder fs-6 text-gray-800">
                                    Issued By:
                                  </div>
                                  <div className="fw-bold fs-7 text-gray-600">
                                    Roadside
                                  </div>
                                </div> */}
                              </div>
                              {order?.cancel_reason && (
                                <div className="flex-grow-1 mb-6">
                                  <span className="fw-bolder fs-6 text-gray-800">
                                    Cancel Reason :{" "}
                                  </span>
                                  <span className="badge badge-light-danger ms-2">
                                    {order?.cancel_reason}
                                  </span>
                                </div>
                              )}
                              {/* <div className="row mb-8">
                              <div className="col-xl-2">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Note :
                                </div>
                              </div>
                              <div className="col-xl-8 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={getNote}
                                  name="notes"
                                  id="notes"
                                  defaultValue={note ? note : order?.notes}
                                />
                              </div>
                              <div className="col-xl-2 fv-row fv-plugins-icon-container">
                                <button
                                  type="submit"
                                  onClick={() => {
                                    addNote();
                                  }}
                                  className="btn btn-primary d-flex"
                                  style={{ marginLeft: "auto" }}
                                >
                                  <span className="indicator-label">Add</span>
                                </button>
                              </div>
                            </div> */}
                              <div className="flex-grow-1">
                                <div className="table-responsive border-bottom mb-9">
                                  <table className="table mb-3">
                                    <thead>
                                      <tr className="border-bottom fs-6 fw-bolder text-muted">
                                        <th className="min-w-175px pb-2">
                                          Description
                                        </th>
                                        <th className="min-w-70px text-end pb-2">
                                          Quantity
                                        </th>
                                        {order?.transaction &&
                                        order?.transaction?.length > 0 ? (
                                          <th className="min-w-80px text-end pb-2">
                                            Price
                                          </th>
                                        ) : null}
                                        {order?.transaction &&
                                        order?.transaction?.length > 0 ? (
                                          <th className="min-w-100px text-end pb-2">
                                            Amount
                                          </th>
                                        ) : null}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="fw-bolder text-gray-700 fs-5 text-end">
                                        <td className="d-flex align-items-center pt-6 text-end">
                                          <i className="fa fa-genderless text-danger fs-2 me-2"></i>
                                          {order?.details}
                                        </td>
                                        <td className="pt-6 text-end">
                                          {order?.details ? 1 : ""}
                                        </td>
                                        {order?.transaction &&
                                        order?.transaction?.length > 0 ? (
                                          <td className="pt-6 text-end">
                                            $
                                            {
                                              order?.transaction?.[0]?.[0]
                                                ?.amount
                                            }
                                          </td>
                                        ) : null}
                                        {order?.transaction &&
                                        order?.transaction?.length > 0 ? (
                                          <td className="pt-6 text-end">
                                            $
                                            {
                                              order?.transaction?.[0]?.[0]
                                                ?.amount
                                            }
                                          </td>
                                        ) : null}
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div className="table-responsive border-bottom mb-9">
                                  <table className="table mb-3">
                                    <thead>
                                      <tr className="border-bottom fs-6 fw-bolder text-muted">
                                        <th className="min-w-175px pb-2">
                                          Service Name
                                        </th>
                                        <th className="min-w-70px text-end pb-2">
                                          Service Price
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="fw-bolder text-gray-700 fs-5 text-end">
                                        <td className="d-flex align-items-center pt-6 text-end">
                                          {order?.service_id?.name
                                            ? order?.service_id?.name
                                            : "N/A"}
                                        </td>
                                        <td className="pt-6 text-end">
                                          {order?.service_id?.price
                                            ? `$${order?.service_id?.price}`
                                            : order?.transaction?.[0]?.[0]
                                                ?.amount
                                            ? `$${order?.transaction?.[0]?.[0]?.amount}`
                                            : "N/A"}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div className="d-flex justify-content-end mb-6">
                                  {order?.transaction?.length > 0 ? (
                                    <div className="mw-300px">
                                      <div className="d-flex flex-stack">
                                        <div className="fw-bold pe-10 text-gray-600 fs-7">
                                          Total
                                        </div>
                                        <div className="text-end fw-bolder fs-6 text-gray-800">
                                          $
                                          {order?.transaction?.length > 0
                                            ? order?.transaction?.[0]?.[0]
                                                ?.amount
                                            : null}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="row mb-8">
                                <div className="col-xl-2">
                                  <div className="fs-6 fw-bold mt-2 mb-3">
                                    Note :
                                  </div>
                                </div>
                                <div className="col-xl-8 fv-row fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={(e) =>
                                      setNoteValue(e?.target?.value)
                                    }
                                    name="notes"
                                    id="notes"
                                    value={noteValue}
                                  />
                                </div>
                                <div className="col-xl-2 fv-row fv-plugins-icon-container">
                                  <button
                                    type="btn"
                                    onClick={() => addNote()}
                                    className="btn btn-primary d-flex"
                                    style={{ marginLeft: "auto" }}
                                  >
                                    <span className="indicator-label">Add</span>
                                  </button>
                                </div>
                              </div>
                              {order?.notes?.[0]?.length > 0 && (
                                <div className="notes-list">
                                  <ul className="">
                                    {order?.notes?.[0]?.length > 0 &&
                                      order?.notes?.[0]?.map((val, ind) => {
                                        return (
                                          <li
                                            className="list-group-item notes-item"
                                            key={ind}
                                          >
                                            <p className="fs-7 text-gray-600 float-right mb-2 d-flex justify-content-between">
                                              <span>Commented at</span>
                                              <span>
                                                {val?.createdAt
                                                  ? dateFormat(
                                                      val?.createdAt,
                                                      "dddd, dd/mm/yyyy, h:MM TT"
                                                    )
                                                  : ""}
                                              </span>
                                            </p>
                                            <p className="fs-6 fw-bold mb-2 d-flex">
                                              <span
                                                style={{ color: "#ff4e00" }}
                                                className="me-2"
                                              >
                                                *
                                              </span>
                                              {val?.note}
                                            </p>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-0 col-xl-4">
                  <div className="m-0 row">
                    <div className="m-0 col-xl-12">
                      <div className="mt-0 mb-5">
                        <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten ">
                          <div className="row mb-0">
                            <div className="row mb-8">
                              <div className="mb-8">
                                <span
                                  className={`badge ${taskStatusColor(
                                    order?.task_status
                                  )} me-2`}
                                >
                                  {taskStatus(order?.task_status)}
                                </span>
                              </div>
                              {canComplete && (
                                <div className="mb-8">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-success"
                                    onClick={() => setShowCompleteModal(true)}
                                  >
                                    Mark as Completed
                                  </button>
                                </div>
                              )}
                              <div className="col-xl-12 fv-row fv-plugins-icon-container mt-3">
                                <Formik
                                  initialValues={{
                                    staff_id: order?.staff_id?.id,
                                    fleet_id: order?.fleet_id?.id,
                                  }}
                                  onSubmit={(values) => {
                                    console.log(values, "values");
                                    sendMessage();
                                    if (
                                      values?.staff_id !== "" &&
                                      values?.staff_id !== undefined &&
                                      values?.fleet_id === undefined
                                    ) {
                                      const token =
                                        localStorage.getItem("token");

                                      var myHeaders = new Headers();
                                      myHeaders.append(
                                        "Authorization",
                                        `Bearer ${token}`
                                      );

                                      var requestOptions = {
                                        method: "GET",
                                        headers: myHeaders,
                                        redirect: "follow",
                                      };

                                      fetch(
                                        `${APIURL}/api/v1/users/${values?.staff_id}`,
                                        requestOptions
                                      )
                                        .then((response) => response.json())
                                        .then((result) => {
                                          dispatch(updateOrder(values, id));
                                          dispatch(
                                            updateStaffStatus(
                                              values?.staff_id,
                                              assignedStaff?.[0]?._id
                                            )
                                          );
                                          pushNotificationClient(
                                            "Staff assigned successfully!",
                                            `A staff ${result?.data?.user?.firstName} is assiggned to your order!`,
                                            order?.customer_id
                                              ?.customer_device_token
                                          );
                                          pushNotificationClient(
                                            "New order assigned successfully!",
                                            // `You have assigned a new order of customer ${order?.customer_id?.firstName}!`,
                                            `You have assigned a new order!`,
                                            result?.data?.user
                                              ?.staff_device_token
                                          );
                                        })
                                        .catch((error) =>
                                          console.log("error", error)
                                        );
                                    } else if (
                                      values?.fleet_id !== "" &&
                                      values?.fleet_id !== undefined &&
                                      values?.staff_id === undefined
                                    ) {
                                      const token =
                                        localStorage.getItem("token");

                                      var myHeaders = new Headers();
                                      myHeaders.append(
                                        "Authorization",
                                        `Bearer ${token}`
                                      );

                                      var requestOptions = {
                                        method: "GET",
                                        headers: myHeaders,
                                        redirect: "follow",
                                      };

                                      fetch(
                                        `${APIURL}/api/v1/users/${values?.staff_id}`,
                                        requestOptions
                                      )
                                        .then((response) => response.json())
                                        .then((result) => {
                                          dispatch(
                                            updateOrderFleet(values, id)
                                          );
                                          dispatch(
                                            updateFleetStatus(
                                              values?.fleet_id,
                                              assignedFleet?.[0]?._id
                                            )
                                          );
                                          pushNotificationClient(
                                            "Fleet assigned successfully!",
                                            `A fleet ${assignedFleet?.[0]?.name} is assiggned to your order!`,
                                            order?.customer_id
                                              ?.customer_device_token
                                          );
                                          pushNotificationClient(
                                            "Fleet assigned successfully with to the new order!",
                                            `You have assigned a new fleet to complete your new order!`,
                                            result?.data?.user
                                              ?.staff_device_token
                                          );
                                        })
                                        .catch((error) =>
                                          console.log("error", error)
                                        );
                                    } else if (
                                      values?.staff_id !== "" &&
                                      values?.staff_id !== undefined &&
                                      values?.fleet_id !== "" &&
                                      values?.fleet_id !== undefined
                                    ) {
                                      const token =
                                        localStorage.getItem("token");

                                      var myHeaders = new Headers();
                                      myHeaders.append(
                                        "Authorization",
                                        `Bearer ${token}`
                                      );

                                      var requestOptions = {
                                        method: "GET",
                                        headers: myHeaders,
                                        redirect: "follow",
                                      };

                                      fetch(
                                        `${APIURL}/api/v1/users/${values?.staff_id}`,
                                        requestOptions
                                      )
                                        .then((response) => response.json())
                                        .then((result) => {
                                          dispatch(
                                            updateOrder(values, id, "true")
                                          );
                                          dispatch(
                                            updateStaffStatus(
                                              values?.staff_id,
                                              assignedStaff?.[0]?._id
                                            )
                                          );
                                          pushNotificationClient(
                                            "Fleet and staff assigned successfully!",
                                            `Staff ${result?.data?.user?.firstName} and Fleet assigned successfully!`,
                                            order?.customer_id
                                              ?.customer_device_token
                                          );
                                          pushNotificationClient(
                                            "New order assigned successfully!",
                                            // `You have assigned a new order of ${order?.customer_id?.firstName}!`,
                                            `You have assigned a new order!`,
                                            result?.data?.user
                                              ?.staff_device_token
                                          );
                                          dispatch(
                                            updateOrderFleet(values, id, "true")
                                          );
                                          dispatch(
                                            updateFleetStatus(
                                              values?.fleet_id,
                                              assignedFleet?.[0]?._id
                                            )
                                          );
                                        })
                                        .catch((error) =>
                                          console.log("error", error)
                                        );
                                    }
                                  }}
                                >
                                  {({
                                    values,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    errors,
                                    touched,
                                  }) => (
                                    <form
                                      className="form"
                                      onSubmit={handleSubmit}
                                      id="myForm"
                                    >
                                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                                        ASSIGN STAFF
                                      </h6>
                                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                        <span>All Active Staffs</span>
                                      </label>
                                      <select
                                        name="staff_id"
                                        className="form-select form-control form-control-solid"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        aria-label="Default select example"
                                      >
                                        <option selected>
                                          {assignedStaff?.[0]?.firstName
                                            ? assignedStaff?.[0]?.firstName
                                            : "Select Staff"}
                                        </option>
                                        {ALLStaffs &&
                                          ALLStaffs?.map((item, index) => {
                                            return (
                                              <option value={item._id}>{`${
                                                item.firstName
                                                  ? item.firstName
                                                  : ""
                                              } ${
                                                item.lastName
                                                  ? item.lastName
                                                  : ""
                                              }`}</option>
                                            );
                                          })}
                                      </select>
                                      {assignedStaff?.[0]?.firstName ? (
                                        <label className="d-flex align-items-center fs-6 fw-bold mb-2 mt-2">
                                          <span>
                                            Currently assigned staff:{" "}
                                            {`${
                                              assignedStaff?.[0]?.firstName
                                                ? assignedStaff?.[0]?.firstName
                                                : ""
                                            } ${
                                              assignedStaff?.[0]?.lastName
                                                ? assignedStaff?.[0]?.lastName
                                                : ""
                                            }`}
                                          </span>
                                        </label>
                                      ) : (
                                        ""
                                      )}
                                      <h6 className="mb-8 mt-18 fw-boldest text-gray-600 text-hover-primary">
                                        ASSIGN FLEET
                                      </h6>
                                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                        <span>All Active Fleets</span>
                                      </label>
                                      <select
                                        name="fleet_id"
                                        className="form-select form-control form-control-solid"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        aria-label="Default select example"
                                      >
                                        <option selected>
                                          {assignedFleet?.[0]?.name
                                            ? assignedFleet?.[0]?.name
                                            : "Select Fleet"}
                                        </option>
                                        {AllFleets?.map((item, index) => {
                                          return (
                                            <option
                                              value={item._id}
                                            >{`${item.name} (${item.registration_no})`}</option>
                                          );
                                        })}
                                      </select>
                                      {assignedFleet?.[0]?.name ? (
                                        <label className="d-flex align-items-center fs-6 fw-bold mb-2 mt-2">
                                          <span>
                                            Currently assigned fleet:{" "}
                                            {assignedFleet?.[0]?.name}(
                                            {
                                              assignedFleet?.[0]
                                                ?.registration_no
                                            }
                                            )
                                          </span>
                                        </label>
                                      ) : (
                                        ""
                                      )}
                                      <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        className="btn btn-primary d-flex mt-4"
                                        style={{ marginLeft: "auto" }}
                                      >
                                        <span className="indicator-label">
                                          {orders?.staff_id && orders?.fleet_id
                                            ? "Update"
                                            : "Assign"}
                                        </span>
                                      </button>
                                    </form>
                                  )}
                                </Formik>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="m-0 col-xl-4">
                    <div className="mt-5 mb-5">
                      <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten "></div>
                    </div>
                  </div> */}
                  </div>
                  <div className="mb-4">
                    <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        PAYMENT DETAILS
                      </h6>
                      <div className="mb-6">
                        <div className="fw-bolder text-gray-800 fs-6">
                          Stripe
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Card Type : ${
                            paymentDetails?.payment_method_details?.card?.brand
                              ? paymentDetails?.payment_method_details?.card
                                  ?.brand
                              : order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.brand
                              : "N/A"
                          }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Country : ${
                            paymentDetails?.payment_method_details?.card
                              ?.country
                              ? paymentDetails?.payment_method_details?.card
                                  ?.country
                              : order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.country
                              : "N/A"
                          }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Card Details : **** **** **** ${
                            paymentDetails?.payment_method_details?.card?.last4
                              ? paymentDetails?.payment_method_details?.card
                                  ?.last4
                              : order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.last4
                              : "N/A"
                          }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Card expiration time : ${
                            paymentDetails?.payment_method_details?.card
                              ?.exp_month
                              ? paymentDetails?.payment_method_details?.card
                                  ?.exp_month
                              : order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.exp_month
                              : "N/A"
                          }/${
                            paymentDetails?.payment_method_details?.card
                              ?.exp_year
                              ? paymentDetails?.payment_method_details?.card
                                  ?.exp_year
                              : order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.exp_year
                              : "N/A"
                          }`}
                        </div>
                        <div className="fw-bold text-gray-600 fs-7">
                          {` Customer Email : ${
                            paymentDetails?.receipt_email
                              ? paymentDetails?.receipt_email
                              : order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? order?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.receipt_email
                              : "N/A"
                          }`}
                        </div>
                      </div>
                      <div className="mb-6">
                        <div className="fw-bold text-gray-600 fs-7">
                          Payment Term:
                        </div>
                        <div className="fw-bolder fs-6 text-gray-800 d-flex align-items-center">
                          14 days
                          <span className="fs-7 text-danger d-flex align-items-center">
                            <span className="bullet bullet-dot bg-danger mx-2"></span>
                            Due in 7 days
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="m-0 row">
                  <div className="m-0 col-xl-4">
                    <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten mb-5">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        CUSTOMER DETAILS
                      </h6>
                      <div className="row mb-5">
                        <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>User Name</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {`${
                              order?.customer_id?.firstName
                                ? order?.customer_id?.firstName
                                : ""
                            } ${
                              order?.customer_id?.lastName
                                ? order?.customer_id?.lastName
                                : ""
                            }`}
                          </div>
                        </div>
                        <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Phone Number </span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {order?.customer_id?.phone}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-5">
                        <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Date</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {dateFormat(
                              order?.customer_id?.createdAt,
                              "d mmmm , yyyy"
                            )}
                          </div>
                        </div>
                        {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>status</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {order?.customer_id?.status}
                          </div>
                        </div> */}
                      </div>
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Email Address</span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {order?.customer_id?.email}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="m-0 col-xl-4">
                    <div className="m-0 mb-5">
                      <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten ">
                        <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                          SERVICE DETAILS
                        </h6>
                        <div className="row mb-5">
                          <div className="col-md-12 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span>Name</span>
                            </label>
                            <div className="fw-bold text-gray-600 fs-7">
                              Roadside Assist{" "}
                            </div>
                          </div>
                        </div>
                        <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                          VEHICLE DETAILS
                        </h6>
                        {order?.vehicle_id?.[0]?.name ? (
                          <div className="row mb-5">
                            <div className="col-md-12 fv-row fv-plugins-icon-container">
                              <div className="row mb-5">
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                    <span>Registration No.</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {order?.vehicle_id?.[0]?.reg_no}
                                  </div>
                                </div>
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                    <span>Name</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {order?.vehicle_id?.[0]?.name}
                                  </div>
                                </div>
                              </div>
                              <div className="row mb-5">
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                    <span>Color</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {order?.vehicle_id?.[0]?.color}
                                  </div>
                                </div>
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                    <span>Model</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {order?.vehicle_id?.[0]?.model}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="m-0 col-xl-4">
                    <div className="m-0">
                      <div className="d-print-none border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten">
                        <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                          ADDRESS DETAILS
                        </h6>
                        {order?.address_id?.[0]?.address ? (
                          <div className="row mb-5">
                            <div className="col-md-12 fv-row fv-plugins-icon-container">
                              <div className="row mb-5">
                                {order?.address_id?.[0]?.address && (
                                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                      <span>Address</span>
                                    </label>
                                    <div className="fw-bold text-gray-600 fs-7">
                                      {order?.address_id?.[0]?.address}
                                    </div>
                                  </div>
                                )}
                                {order?.address_id?.[0]?.city && (
                                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                      <span>City</span>
                                    </label>
                                    <div className="fw-bold text-gray-600 fs-7">
                                      {order?.address_id?.[0]?.city}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="row mb-5">
                                {order?.address_id?.[0]?.state && (
                                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                      <span>State</span>
                                    </label>
                                    <div className="fw-bold text-gray-600 fs-7">
                                      {order?.address_id?.[0]?.state}
                                    </div>
                                  </div>
                                )}
                                {order?.address_id?.[0]?.street_no && (
                                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-bold mb-4">
                                      <span>Street No</span>
                                    </label>
                                    <div className="fw-bold text-gray-600 fs-7">
                                      {order?.address_id?.[0]?.street_no}
                                    </div>
                                  </div>
                                )}
                                {order?.address_id?.[0]?.zip && (
                                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                      <span>Zip</span>
                                    </label>
                                    <div className="fw-bold text-gray-600 fs-7">
                                      {order?.address_id?.[0]?.zip}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              loader()
            )}
          </div>
        </div>
        <ConfirmationModal
          isOpen={showCompleteModal}
          onClose={() => setShowCompleteModal(false)}
          onConfirm={handleMarkCompleted}
          title="Mark Order as Completed"
          message={`Mark order ${
            order?.invoice_no || ""
          } as completed? The assigned staff and fleet vehicle will be set back to available.`}
          confirmText="Yes, Mark Completed"
          confirmButtonClass="btn-success"
          isLoading={completing}
        />
      </Layout>
    </React.Fragment>
  );
};
export default EditOrders;
